import { SkeletonBox } from '@billy/design-system'
import { ReactElement } from 'react'

export const EInvoicingReasonLabelSkeleton = (): ReactElement => <SkeletonBox height={20} width={320} />
